// extracted by mini-css-extract-plugin
export default {"inputContainer":"PhotoInputGridItem_inputContainer__Tal3X","input":"PhotoInputGridItem_input__F6+Xm"};